import React from "react";
import PropTypes from "prop-types";

const Paste = (props) => {
  return (
    <div>
      <a href="#input_grades">
        <i className="fa fa-clipboard paste" aria-hidden="true">
          <span>Paste Grades</span>
        </i>
      </a>
    </div>
  );
};

Paste.propTypes = {};

export default Paste;
